import { useEffect } from 'react';
import { useFlags as LDUseFlags, useLDClient } from 'launchdarkly-react-client-sdk';

interface Flags {
  enableOssCarePartnerRideDetails: boolean;
}

export const LaunchDarklyProvider = ({ userSlug, children }) => {
  const ldClient = useLDClient();

  useEffect(() => {
    if (userSlug && ldClient) {
      ldClient.identify({ key: userSlug });
    }
  }, [userSlug, ldClient]);

  return children;
};

const useFlags = (): Flags => {
  const flags = LDUseFlags();

  return {
    enableOssCarePartnerRideDetails: flags.railsCareConsoleOssRideDetails || false,
  };
};

export { useFlags };
